import { Auth } from '@prime/auth';
import { APP_CONFIG } from '../../../../config/appConfig';

const OAuthClient = new Auth({
  url: APP_CONFIG.JUSTIN_URL,
  client_id: APP_CONFIG.CLIENT_ID,
  client_secret: APP_CONFIG.SECRET_ID,
});

export default OAuthClient;
